module.exports = __webpack_public_path__ + "static/img/kuang.2700a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataV/kuang.png
// module id = m8HZ
// module chunks = 1